<template>
  <div class="fade-in-box" :class="{ visible }" ref="fadeInBoxRef">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    const ob = new IntersectionObserver(([item]) => {
      if (item.isIntersecting) {
        // 完全出现在视口中：延迟加载
        this.visible = true;
        // 处理过的需要移除监听
        ob.unobserve(item.target);
      }
    }, { threshold: [0.3] });
    ob.observe(this.$refs['fadeInBoxRef']);
  },
}
</script>

<style lang="less" scoped>
.fade-in-box {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.4s linear;
  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
